import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";

export default GrComponentFactory.createClass({
  displayName: "UserStatusHeader",

  propTypes: {
    book: GrPropTypes.book().isRequired,
    headerText: React.PropTypes.string,
  },

  render(){
    return (
            <span>
              {this.props.headerText}
              <a className="gr-hyperlink gr-hyperlink--bold"
                 href={this.props.book.bookUrl}>{this.props.book.title}</a>
            </span>
    );
  },
});
